import axios from "./axios";

const getValidToken = (type,token) => {
  let session_token = sessionStorage.getItem("temporary_access_token");
  let header_token = axios.defaults.headers.common['Authorization'];
  let finalToken = {}
  if(session_token && header_token || session_token)
  {
    if(type === 'guide-comments')
    {
      finalToken["X-Guide-Access-Token"] = token?token:session_token;
    }
    else 
    {
      finalToken["X-Interviewer-Request-Access-Token"] = session_token;
    }

    finalToken["Authorization"]= null;
  }
  else
  {
    finalToken["Authorization"] = header_token;
  }
  return finalToken;
}

export const getGuidePreviewDataAPI = (guide_id, positionParams)=>{
    let guideUrl = positionParams ? `/guides/${guide_id}?position_id=${positionParams}` : `/guides/${guide_id}`
    return axios.get(guideUrl, {
      headers:{...getValidToken()}
    }).then(res=>{
      return res;
    }).catch(error=>{
      return error?.response;
  })
}


/*          Interview Guide Comments          */

const getTokenConfig = (token) => {
  let config ={};
  if(token)
  {
    config = {
      headers : {
        "X-Guide-Access-Token":token,
      }
    }
  }
  return config;
}
// Get all comments in a guide
export const getAllGuideCommentsAPI = (payload, token) => {
 
    return axios.post(`/guide-comment/all`,payload,{
      headers:getValidToken('guide-comments',token)
    }).then(response=>{
      return response;
    }).catch(error=>{
      throw error?.response;
  });
}

//  Add Comments to a particular section in guide
export const addCommentAPI = (payload,token) => {
  return axios.post(`/guide-comment/add`,payload,{
    headers:getValidToken('guide-comments',token)
  }).then(response=>{
    return response;
  }).catch(error=>{
    throw error?.response;
  });
}

// Edit status of a comment
export const editCommentStatusAPI = (payload,token) => {
  return axios.post(`/guide-comment/edit-status`,payload,{
    headers:getValidToken('guide-comments',token)
  }).then(response => {
    return response;
  }).catch(error => {
    throw error?.response;
  });
}

//  Add thread to a comment
export const addThreadAPI = (payload,token) => {
    return axios.post(`/guide-comment/add-thread`,payload,{
      headers:getValidToken('guide-comments',token)
    }).then(response=>{
        return response;
    }).catch(error=>{
      throw error?.response;
  });
}

//  Delete a thread
export const deleteThreadAPI = (payload,token) => {
  return axios.post(`/guide-comment/delete-thread`,payload,{
    headers:getValidToken('guide-comments',token)
  }).then(response => {
    return response;
  }).catch(error => {
    throw error?.response;
  });
}